<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemTipoSir2Monit"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="tipoSir.id === 0 ? adicionarTipoSir2Monit() : editarTipoSir2Monit()"
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="tipoSir.descricao"
                >Tipo</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <div>Isento</div>
              <toggle-button v-model="tipoSir.isento" :sync="true" />
            </div>
            <div class="col-sm-4">
              <div>Subtipo</div>
              <toggle-button v-model="tipoSir.subTipo" :sync="true" />
            </div>
            <div class="col-sm-4">
              <div>Possui upload de arquivos</div>
              <toggle-button v-model="tipoSir.upload" :sync="true" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import Sirs from './mixim/sirs'
Vue.mixin(Sirs)

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo de SIR',
      titlePDF: 'Lista de Tipo de apresentação',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'descricao', label: 'Tipo', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      tipoSir: {},
      actions: [
        {
          button: true,
          funcaoButton: 'editTipoSir2Monit',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteTipoSir2Monit',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    deleteTipoSir2Monit: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSir2 + 'TipoSir2Monit/Excluir/id?id=' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoSir2Monit()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.tipoSir = {}
      this.tipoSir.id = 0
      this.titleModal = 'Adicionar tipo de SIR-2'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editarTipoSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSir2 + 'TipoSir2Monit/Alterar',
          this.tipoSir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarTipoSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSir2 + 'TipoSir2Monit/Adicionar',
          this.tipoSir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editTipoSir2Monit: function (_, item) {
      this.tipoSir = { ...item }
      this.titleModal = 'Editar tipo de SIR-2'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    }
  },
  mounted: function () {
    this.listarTipoSir2Monit()
  }
}
</script>
